import {MailFolderEnum} from "components/src/api/portal/generated";
import {useSidebarCollapsed} from "components/src/sidebar/SideBar";
import {
    EnterprisePortalPropertiesContextProvider
} from "enterprise-components/src/context/EnterprisePortalPropertiesContextProvider";
import {WebmailReloadContextProvider} from "enterprise-components/src/context/WebmailReloadContext";
import {
    EnterprisePortalDashboardExtension
} from "enterprise-components/src/dashboard/EnterprisePortalDashboardExtension";
import {
    useEnterprisePortalPropertiesContext
} from "enterprise-components/src/hook/UseEnterprisePortalPropertiesContext";
import {Messages} from "enterprise-components/src/webmail/Messages";
import {WebmailQuota} from "enterprise-components/src/webmail/WebmailQuota";
import {PortalApp} from 'portal/src/PortalApp'
import React from "react";
import ReactDOM from 'react-dom/client'
import 'components/src/lang/i18n.js';
import {Navigate, Route} from "react-router-dom";
import {EnterprisePortalSidebar} from "./EnterprisePortalSidebar";
import 'components/src/fonts/Manrope-VariableFont_wght.ttf'

export const SidePanel= () =>
{
    const sideBarCollapsed = useSidebarCollapsed();
    const {properties} = useEnterprisePortalPropertiesContext();

    if (sideBarCollapsed || !properties?.webmailEnabled) {
        return null;
    }

    return(
        <WebmailQuota/>
    )
}

const AuthenticatedWrapper = ({children}: {children: React.ReactNode}) => (
    <EnterprisePortalPropertiesContextProvider>
        <WebmailReloadContextProvider>
            {children}
        </WebmailReloadContextProvider>
    </EnterprisePortalPropertiesContextProvider>
);

ReactDOM.createRoot(document.getElementById('root')!).render(
    <PortalApp Sidebar={EnterprisePortalSidebar}
               OptionalSidePanel={SidePanel}
               AuthenticatedWrapper={AuthenticatedWrapper}
               DashboardBeforeContent={<EnterprisePortalDashboardExtension/>}
    >
        <Route path={"messages"} element={
            <Navigate to="inbox" replace />
        } />
        <Route path={"messages/inbox"} element={
            <Messages folder={MailFolderEnum.Inbox}/>
        } />
        <Route path={"messages/sent"} element={
            <Messages folder={MailFolderEnum.Sent}/>
        } />
    </PortalApp>
)
